import { createElement } from 'react';
import { node, string } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose } from '../chunk-ad6ad343.js';
import 'reakit/Label';
import _Label from './styled.js';

var Label = function Label(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return createElement(_Label, props, children);
};

var labelPropTypes = {
  children: node.isRequired,
  className: string,
  htmlFor: string
};
Label.propTypes = labelPropTypes;
var labelDefaultProps = {
  htmlFor: undefined,
  className: undefined
};
Label.defaultProps = labelDefaultProps; // @ts-ignore

export default Label;
export { Label, labelDefaultProps, labelPropTypes };